let isMobileToggleBound = false;

function transportationToggle() {
    const isMobile = $(window).width() < 1024;

    if (isMobile && !isMobileToggleBound) {
        $('.parks_recreation > .wp-block-heading').each(function (){
            const content = $(this).text();
            $(this).text('').append(`<button type="button" aria-expanded="false">${content}</button>`)
            $(this).siblings().attr('aria-hidden', 'true');
        });
        $('body').on('click.mobileToggle', '.parks_recreation > .wp-block-heading button', function (e) {
            e.preventDefault();
            $(this).parent().toggleClass('open');
            $(this).attr('aria-expanded', $(this).parent().hasClass('open') ? 'true' : 'false');
            $(this).parent().siblings().attr('aria-hidden', $(this).parent().hasClass('open') ? 'false' : 'true');
            $(this).parent().siblings().slideToggle(150, function () {
                if ($(this).is(':visible')) {
                    $(this).css('display', 'flex');
                }
            });
        });
        isMobileToggleBound = true;
    } else if (!isMobile && isMobileToggleBound) {
        $('.parks_recreation > .wp-block-heading').each(function (){
            const content = $(this).text();
            $(this).text('').append(`${content}`)
            $(this).siblings().removeAttr('aria-hidden');
        });
        $('body').off('click.mobileToggle');
        isMobileToggleBound = false;
    }
}

$(document).ready(function () {
    transportationToggle();
    $(window).on('resize', transportationToggle);
});